import { useMutation, UseMutationResult } from "@tanstack/react-query";
import axios from "axios";
import { format } from "date-fns";
import { useAuthStore } from "../../../../console/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";

export interface OrderStatusItem {
    order_date: string;
    sale_count: number;
    sale_amount: number;
    payment_count: number;
    payment_amount: number;
    outstanding_amount: number;
}

interface SalesStatisticsRequest {
    start_order_date: Date | string;
    end_order_date: Date | string;
}

export const useGetSalesStatistics = (): UseMutationResult<OrderStatusItem[], Error, SalesStatisticsRequest, unknown> => {
    const accessToken = useAuthStore(state => state.accessToken);

    // Date 객체를 문자열로 변환
    const formatDate = (date: Date | string): string => {
        if (date instanceof Date) {
            return format(date, "yyyy-MM-dd");
        }
        return date;
    };

    return useMutation<OrderStatusItem[], Error, SalesStatisticsRequest>({
        mutationFn: async ({ start_order_date, end_order_date }: SalesStatisticsRequest) => {
            const startDate = formatDate(start_order_date);
            const endDate = formatDate(end_order_date);

            const response = await axios.get(`${enum_api_uri.get_order_stats}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
                params: {
                    start_order_date: startDate,
                    end_order_date: endDate,
                },
            });
            return response.data.data.statsList;
        },
    });
};
